interface GrantPropagationWarningProps {
  userLabel: string | null;
}

// Feature 011 (FR-028) — inline cue surfaced after every grant/revoke toggle
// so the Admin remembers that the change takes effect on the editor's next
// login (matches the 8-hour JWT TTL bound).
export function GrantPropagationWarning({ userLabel }: GrantPropagationWarningProps) {
  if (!userLabel) return null;
  return (
    <p
      role="status"
      className="text-xs text-ink-soft italic mt-1"
    >
      Editor <span className="font-medium">{userLabel}</span> picks this change up on next login.
    </p>
  );
}
